<canvas *ngIf="!isPublic" #bundleIcon class="bundle__image"></canvas>
<img *ngIf="isPublic" class="bundle__image" alt="" [src]="publicImageSrc" (error)="handleMissingImage()">
